var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneBlueSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "7wpaa",
    d: "M927.814 257c-.945 0-2.036-.233-3.236-.7-2.485-.968-5.19-2.838-7.617-5.265-5.194-5.193-7.387-11.136-4.994-13.53l1.024-1.024a1.648 1.648 0 0 1 2.327 0l3.509 3.51a1.647 1.647 0 0 1 0 2.326l-.89.89c-.143.143-.226.706.133 1.667.378 1.011 1.117 2.113 2.026 3.023 1.98 1.98 4.26 2.594 4.692 2.16l.89-.89a1.647 1.647 0 0 1 2.327 0l3.508 3.51c.311.31.483.724.483 1.163 0 .44-.172.853-.483 1.164l-1.023 1.024c-.647.647-1.56.972-2.676.972"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-911 -236)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#7wpaa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlueSmall);
export default __webpack_public_path__ + "static/media/phone-blue-small.695ef59bae8f503238e5b120e6d1263e.svg";
export { ForwardRef as ReactComponent };